import { render, staticRenderFns } from "./DevicesView.vue?vue&type=template&id=0644feb8&scoped=true"
import script from "./DevicesView.vue?vue&type=script&lang=ts"
export * from "./DevicesView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0644feb8",
  null
  
)

export default component.exports